module.exports = __webpack_public_path__ + "static/media/Fruits.5c2e4c4c.png";